<template>
  <div>
    <el-form size="mini" label-position="top">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_financialRiskAssessment') || '财务风险评估'"
          >
            <el-input
              :value="
                formData.v_riskLevel ||
                  $l('form_label_financialRiskAssessment_N') ||
                  '待评估'
              "
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_paymentTerms') || '默认付款条件'"
          >
            <el-input v-model="formData.v_paymentTerms" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('form_label_discountSalesAmount') || '货款结算是否包含佣金'
            "
          >
            <el-input v-model="formData.v_discountSalesAmount" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <p class="el-form-item__label m-0 mt-1" style="float:none;text-align:left;">
      {{ '接单抬头' }}
    </p>
    <el-form
      v-for="(form, index) in listTakeOrder"
      :key="index"
      size="mini"
      label-position="top"
      class="list-form"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_takeOrderOrgCode') || '接单抬头设置'"
          >
            <span>{{ form.takeOrderOrgName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_takeOrderOrgName') || '收汇抬头'"
          >
            <span>{{ form.takeOrderOrgName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_takeOrderType') || '订单类型限制'"
          >
            <span>{{ form.v_takeOrderType }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_executeOrgCode') || '国内业务执行公司'"
          >
            <span>{{ form.executeOrgName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('form_label_executeOrgName') || '国内公司采购合同甲方抬头'
            "
          >
            <span>{{ form.executeOrgName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <EmptyContent v-if="!listTakeOrder || !listTakeOrder.length" />
  </div>
</template>

<script>
import EmptyContent from '../empty-content'
export default {
  components: { EmptyContent },
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      listTakeOrder: [],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getCustData()
      this.getTakeOrderData()
    },
    async getCustData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async getTakeOrderData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerTakeOrderListApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body?.data || []
      this.listTakeOrder = data.map((item) => ({ ...item, enableEdit: false }))
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .list-form.el-form {
    background-color: #f4f6f9;
    padding: 15px;
    padding-bottom: 5px;
    border-radius: 5px;
    margin-bottom: 16px;
    .el-form-item__content {
      font-weight: 600;
    }
  }
  .list-form.el-form:last-child {
    margin-bottom: 0;
  }
}
</style>
